__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-05-04-1777888009-stable-dev/";